module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/lung_details-ec09f6dcbcbe46e86cf2903baae2aef6.png";